import { set } from 'immutadot'
import {
    INIT_APP,
    UPDATE_CSRF_TOKEN,
} from './actions'
import { ACTIVATE_COLLABORATIVE_INDEXER_STATUS } from '../collaborativeIndexations/actions'

export const app = (state = {}, action) => {
    switch (action.type)
    {
        case INIT_APP:
            return {
                ...state,
                ...action.app,
            }

        case UPDATE_CSRF_TOKEN:
            return set(state, 'security.csrfToken', action.csrfToken)

        case ACTIVATE_COLLABORATIVE_INDEXER_STATUS:
            return set(state, 'userProfile.isCollaborativeIndexerStatusActive', true)

        default:
            return state
    }
}
